import { useEffect, useRef } from 'react';
import { TURNSTILE_SITE_KEY } from 'const/ConstBase';

interface Props {
    id: string;
    onCaptchaChange: (value: string) => void;
    onCaptchaError: () => void;
    onCaptchaExpire: () => void;
}

const AppTurnstile = ({
    id,
    onCaptchaChange,
    onCaptchaError,
    onCaptchaExpire,
}: Props) => {
    const turnstileRendered = useRef(false);

    const renderTurnstile = () => {
        (window as any).turnstile.render(`#${id}`, {
            sitekey: String(TURNSTILE_SITE_KEY),
            callback: (token: string) => onCaptchaChange(token),
            'error-callback': onCaptchaError,
            'expired-callback': onCaptchaExpire,
        });

        turnstileRendered.current = true; // Mark as initialized
    };

    useEffect(() => {
        if (!(window as any).turnstile || turnstileRendered.current) {
            return;
        }

        renderTurnstile();
    }, [id, onCaptchaChange, onCaptchaError, onCaptchaExpire]);

    return (
        <div style={{ display: 'block', flexFlow: 'row' }}>
            <div className='cf-turnstile' id={id} data-size='flexible'></div>
        </div>
    );
};

export default AppTurnstile;
